import React from "react";
import { Input } from "@mantine/core";

export default function TimeField({
  label = "Time",
  required = false,
  value = "",
  onChange,
  disabled = false,
  min = "",
  max = "",
  error = "",
}) {
  const formatTime = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    const date = new Date();
    date.setHours(parseInt(hours, 10));
    date.setMinutes(parseInt(minutes, 10));
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const getLabel = () => {
    let labelText = label;
    if (min || max) {
      labelText += " (";
      if (min) labelText += `earliest: ${formatTime(min)}`;
      if (min && max) labelText += ", ";
      if (max) labelText += `latest: ${formatTime(max)}`;
      labelText += ")";
    }
    return labelText;
  };

  return (
    <Input.Wrapper label={getLabel()} required={required} error={error}>
      <Input
        type="time"
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        min={min}
        max={max}
      />
    </Input.Wrapper>
  );
}
